import { Link } from 'react-router-dom';
import { useContent } from '../App.jsx';
import PageHero from '../components/PageHero.jsx';
import { ArrowIcon, CheckIcon } from '../components/Icons.jsx';
import { isEarlyBird } from '../lib/pricing.js';

export default function PricingPage() {
  const { content } = useContent();
  const earlyBird = isEarlyBird(content);
  const price = earlyBird ? content.pricing.earlyBirdPrice : content.pricing.regularPrice;
  const groupPrice = earlyBird ? content.pricing.earlyBirdGroupPrice : content.pricing.regularGroupPrice;
  return (
    <>
      <PageHero eyebrow="Straightforward pricing" title="One registration. The whole workshop." body="Classes, Saturday lunch, Friday's instructor recital, and the Saturday night ceilidh are all part of your weekend." />
      <section className="section page-width pricing-layout">
        <article className="price-card featured-price">
          <div><p className="eyebrow">{earlyBird ? 'Early-bird registration' : 'Workshop registration'}</p><p className="price"><sup>$</sup>{price}</p><span>per attendee</span></div>
          <ul>
            <li><CheckIcon /> All Saturday and Sunday classes</li>
            <li><CheckIcon /> Friday instructor recital ticket</li>
            <li><CheckIcon /> Saturday lunch</li>
            <li><CheckIcon /> Saturday night ceilidh</li>
          </ul>
          <Link className="button" to="/register">Register now <ArrowIcon /></Link>
        </article>
        <div className="pricing-details">
          <article><p className="eyebrow">Bring your band</p><h2>${groupPrice} each</h2><p>Register {content.pricing.groupMinimum} or more attendees together to unlock group pricing automatically.</p></article>
          <article><p className="eyebrow">Workshop shirt</p><h2>${content.pricing.shirtPrice}</h2><p>Add an official workshop shirt to any attendee registration while supplies last.</p></article>
          <article><p className="eyebrow">A couple details</p><h2>Good to know</h2><p>A {content.pricing.processingFeePercent}% payment-processing fee is added at checkout. Refunds are unavailable after October 31, {content.event.year}.</p></article>
        </div>
      </section>
    </>
  );
}
